import AgendaGroup from './AgendaGroup/AgendaGroup.builder';
import AgendaHero from './AgendaHero/AgendaHero.builder';
import Header from './Header/Header.builder';
import Page from './Page/Page.builder';
import RegistrationForm from './RegistrationForm/RegistrationForm.builder';
import Session from './Session/Session.builder';
import Sponsors from './Sponsors/Sponsors.builder';

export default [
  AgendaGroup,
  AgendaHero,
  Header,
  Page,
  RegistrationForm,
  Session,
  Sponsors,
];
